export const IS_HINT_SHOWN = 'isGoalsHintShown';
